<template>
  <div class="w-full flex flex-col items-center justify-center">
    <div class="w-full h-12 hidden sm:flex"></div>
    <div class="card flex flex-col bg-white rounded max-w-sm w-full">
      <div class="flex flex-col w-full space-y-2">
        <button v-if="isEdit()" class="nxp-back-btn hidden sm:flex" @click="handleBackward">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask id="mask0_857_10485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
              height="16">
              <rect width="16" height="16" fill="#696969" />
            </mask>
            <g mask="url(#mask0_857_10485)">
              <path
                d="M9.33362 11.7688L5.56445 7.99964L9.33362 4.23047L10.0361 4.93297L6.96945 7.99964L10.0361 11.0663L9.33362 11.7688Z"
                fill="#A9A9A9" />
            </g>
          </svg>
          Voltar
        </button>
        <span v-if="jobPositionReference" class="nxp-job-title">
          {{ jobPositionReference }}
        </span>
        <h1 class="nxp-title-form">
          Preencha seus dados
        </h1>
        <span class="nxp-subtitle-form">
          Adicione seus dados pessoais e preferências profissionais para completar seu perfil
        </span>
      </div>

      <div class="flex w-full flex-col mt-8 mb-6 space-y-2">
        <h3 class="nxp-section-title">
          Dados pessoais
        </h3>
        <hr class="custom-hr">
      </div>

      <div v-if="requiresProfileCompletion" class="nxp-profile-completion-alert mb-4">
        <span class="nxp-profile-completion-alert__text">
          Complete seu perfil: preencha CPF e telefone para continuar.
        </span>
      </div>

      <div class="w-full flex flex-col space-y-4">
        <div class="w-full flex flex-col space-y-2">
          <label for="nome" class="nxp-label">
            Nome completo *
          </label>
          <vs-input class="w-full no-icon-border mb-1" v-model="payload.name" id="name" name="nome" type="text"
            v-validate="'required|min:3|max:80'" data-vv-validate-on="blur" @blur="doCaclulateProgress" />
          <span class="text-danger text-sm">
            {{ errors.first("nome") }}
          </span>
        </div>

        <div class="w-full flex flex-col space-y-2">
          <label for="gender-basic" class="nxp-label">
            Identidade de gênero
            <span> - Opcional</span>
          </label>
          <v-select
            id="gender-basic"
            class="w-full"
            :options="options.genders"
            :reduce="(gender) => gender.value"
            v-model="payload.gender"
          >
            <template v-slot:option="option">
              <div class="gender">
                <h2>{{ option.label }}</h2>
                <p>{{ option.description }}</p>
              </div>
            </template>
          </v-select>
        </div>

        <!-- CPF (somente quando não existir SSN) -->
        <div v-if="showSsnInput" class="w-full flex flex-col space-y-2">
          <label for="cpf" class="nxp-label">CPF *</label>
          <vs-input
            class="w-42 no-icon-border mb-1"
            v-model="payload.ssn"
            id="cpf"
            name="cpf"
            type="text"
            v-mask="'###.###.###-##'"
            placeholder="CPF (Somente números)"
            v-validate="'required|cpf'"
            data-vv-validate-on="blur"
            @blur="doCaclulateProgress"
          />
          <span class="text-danger text-sm">{{ errors.first('cpf') }}</span>
        </div>

        <div class="w-full flex flex-col space-y-2">
          <label for="bithday" class="nxp-label">Data de nascimento *</label>
          <vs-input ref="birthdayField" class="w-32 no-icon-border mb-1" id="bithday" name="nascimento" type="text"
            label="" v-mask="'##/##/####'" v-validate="'required|birthday'" data-vv-validate-on="blur"
            placeholder="___/___/______" v-model="payload.birthday" @blur="doCaclulateProgress" />
          <span class="text-danger text-sm">{{ errors.first("nascimento") }}</span>
        </div>

        <div class="w-full flex flex-col space-y-1">
          <label class="nxp-label" for="phonenumber"> Telefone * </label>
          <VuePhoneNumberInput id="phonenumber" default-country-code="BR" v-model="payload.telephone"
            valid-color="#000000" :style="{ opaticy: 0.2 }" :translations="{
              countrySelectorLabel: 'Código',
              countrySelectorError: 'Selecione um País',
              phoneNumberLabel: 'Número de Telefone',
              example: 'Exemplo:',
            }" />
          <span class="text-danger text-sm">{{ telephoneError }}</span>
        </div>

        <div class="w-full flex flex-col space-y-2 py-4">
          <label class="nxp-label">
            Foto do perfil
          </label>
          <label v-if="!fileUpload" class="nxp-file-input-group " for="file">
            Insira sua foto
            <input class="nxp-file-input" id="file" ref="file" type="file" accept=".jpg,.jpeg,.png"
              v-on:change="handleFileUpload()" />
          </label>

          <div v-if="fileUpload" class="nxp-file-input-success">
            <div class="divider" :style="{ background: color }"></div>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <g clip-path="url(#clip0_917_23314)">
                <path
                  d="M7.51066 12.7765L12.0636 8.22334L11.198 7.35782L7.51901 11.0366L5.72203 9.21766L4.82596 10.0915L7.51066 12.7765ZM3.92878 16.0005C3.53273 16.0005 3.19916 15.8639 2.92809 15.5906C2.65702 15.3173 2.52148 14.9828 2.52148 14.5871V1.41345C2.52148 1.01769 2.65812 0.683173 2.93139 0.409904C3.20466 0.136635 3.53917 0 3.93494 0H10.7415L14.3021 3.56056V14.5871C14.3021 14.9828 14.1654 15.3173 13.892 15.5906C13.6186 15.8639 13.2838 16.0005 12.8878 16.0005H3.92878ZM9.90634 4.39575V1.14289H3.93494C3.86724 1.14289 3.80526 1.1711 3.749 1.22751C3.69258 1.28378 3.66438 1.34576 3.66438 1.41345V14.5871C3.66438 14.6548 3.69258 14.7167 3.749 14.773C3.80526 14.8294 3.86724 14.8576 3.93494 14.8576H12.8886C12.9563 14.8576 13.0183 14.8294 13.0746 14.773C13.131 14.7167 13.1592 14.6548 13.1592 14.5871V4.39575H9.90634Z"
                  :fill="color" />
              </g>
              <defs>
                <clipPath id="clip0_917_23314">
                  <rect width="16" height="16" fill="white" transform="translate(0.412109)" />
                </clipPath>
              </defs>
            </svg>
            <p>{{ payload.photo_url ? payload.photo_url.split('/').pop().slice(-20) : null }}</p>
            <button @click="removeFile">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path
                  d="M7.16889 16.5841C6.79917 16.5841 6.48341 16.4533 6.2216 16.1916C5.95993 15.9298 5.8291 15.614 5.8291 15.2443V5.50076H4.8291V4.41742H8.41244V3.51367H12.4124V4.41742H15.9958V5.50076H14.9958V15.2353C14.9958 15.6206 14.8663 15.9417 14.6072 16.1987C14.3482 16.4556 14.0311 16.5841 13.656 16.5841H7.16889ZM13.9124 5.50076H6.91244V15.2443C6.91244 15.3192 6.93646 15.3806 6.98452 15.4287C7.03257 15.4767 7.09403 15.5008 7.16889 15.5008H13.656C13.7201 15.5008 13.7789 15.474 13.8322 15.4205C13.8857 15.3672 13.9124 15.3085 13.9124 15.2443V5.50076ZM8.7491 14.0008H9.83223V7.00076H8.7491V14.0008ZM10.9926 14.0008H12.0758V7.00076H10.9926V14.0008Z"
                  fill="#4F4F4F" />
              </svg>
              Excluir
            </button>
          </div>
        </div>

      </div>

      <div class="flex w-full flex-col mt-10 mb-6 space-y-2">
        <h3 class="nxp-section-title">
          Dados profissionais
        </h3>
        <hr class="custom-hr">
      </div>

      <div class="w-full flex flex-col space-y-4">

        <!-- TODO: Descomentar em uma próxima versão  -->
        <!-- <vs-col
          :class="include_social_name ? 'my-5' : 'my-10'"
          vs-w="6"
          vs-xs="12"
          vs-sm="12"
        >
          <vs-col v-if="!include_social_name" class="flex" vs-w="12">
            <vs-switch color="primary" v-model="include_social_name" />
            <p class="ml-4">Incluir campo de Nome Social</p>
            <Tooltip
              :text="social_name_tooltip"
              :position="isMobile ? 'bottom-right' : 'bottom-left'"
            />
          </vs-col>

          <div v-if="include_social_name">
            <div class="flex items-center my-2">
              <label class="vs-select--label">Nome Social</label>
              <Tooltip
                :text="social_name_tooltip"
                :position="isMobile ? 'bottom-right' : 'bottom-left'"
              />
            </div>
            <vs-input
              v-show="include_social_name"
              class="w-full no-icon-border mb-1"
              type="text"
              placeholder="Insira aqui o seu nome social"
              v-model="payload.social_name"
            />
          </div>
        </vs-col> -->

        <div class="w-full flex flex-col space-y-2">
          <label for="remuneration" class="nxp-label">Pretensão salarial <span> - Opcional</span></label>
          <validation-provider name="remuneration" v-slot="{ errors }" mode="lazy">
            <vs-input class="w-42 no-icon-border mb-1" v-model="payload.remuneration" id="remuneration"
              name="remuneration" placeholder="0,00" type="text" @input="handleMaskRemuneration"
              :danger="errors.length > 0" :danger-text="errors[0]" />
          </validation-provider>
        </div>

        <div class="w-full flex flex-col space-y-2">

          <label for="linkedin_url" class="nxp-label">Seu Linkedin <span> - Opcional</span></label>
          <validation-provider id="linkedin_url" name="linkedin_url" rules="linkedin_domain" v-slot="{ errors }"
            mode="lazy">
            <vs-input class="w-full no-icon-border mb-1" v-model="payload.linkedin_url" name="linkedin_url" type="text"
              placeholder="https://www.linkedin.com/in/seu-nome" @blur="doCaclulateProgress" :danger="errors.length > 0" :danger-text="errors[0]" />
          </validation-provider>
        </div>

        <div class="w-full flex flex-col space-y-2 py-4">
          <label class="nxp-label">
            Currículo
          </label>
          <label v-if="!CvUploaded" class="nxp-file-input-group " for="fileCV">
            Insira seu currículo
            <input class="nxp-file-input" id="fileCV" ref="fileCV" type="file"
              accept="application/pdf,application/msword,.doc,.docx,.pdf" @change="handleCVUpload" />
          </label> 

          <div v-if="CvUploaded" class="cv-uploaded-container">
            <div class="nxp-file-input-success">
              <div class="divider" :style="{ background: color }"></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <g clip-path="url(#clip0_917_23314)">
                  <path
                    d="M7.51066 12.7765L12.0636 8.22334L11.198 7.35782L7.51901 11.0366L5.72203 9.21766L4.82596 10.0915L7.51066 12.7765ZM3.92878 16.0005C3.53273 16.0005 3.19916 15.8639 2.92809 15.5906C2.65702 15.3173 2.52148 14.9828 2.52148 14.5871V1.41345C2.52148 1.01769 2.65812 0.683173 2.93139 0.409904C3.20466 0.136635 3.53917 0 3.93494 0H10.7415L14.3021 3.56056V14.5871C14.3021 14.9828 14.1654 15.3173 13.892 15.5906C13.6186 15.8639 13.2838 16.0005 12.8878 16.0005H3.92878ZM9.90634 4.39575V1.14289H3.93494C3.86724 1.14289 3.80526 1.1711 3.749 1.22751C3.69258 1.28378 3.66438 1.34576 3.66438 1.41345V14.5871C3.66438 14.6548 3.69258 14.7167 3.749 14.773C3.80526 14.8294 3.86724 14.8576 3.93494 14.8576H12.8886C12.9563 14.8576 13.0183 14.8294 13.0746 14.773C13.131 14.7167 13.1592 14.6548 13.1592 14.5871V4.39575H9.90634Z"
                    :fill="color" />
                </g>
                <defs>
                  <clipPath id="clip0_917_23314">
                    <rect width="16" height="16" fill="white" transform="translate(0.412109)" />
                  </clipPath>
                </defs>
              </svg>
              <a
                v-if="isEdit() && payload.curriculum_url"
                :href="payload.curriculum_url"
                target="_blank"
                rel="noopener noreferrer"
                class="cv-filename-link"
              >
                {{ curriculumDisplayName }}
              </a>
              <p v-else>
                {{ curriculumDisplayName }}
              </p>
              <button @click="removeFileCV">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <path
                    d="M7.16889 16.5841C6.79917 16.5841 6.48341 16.4533 6.2216 16.1916C5.95993 15.9298 5.8291 15.614 5.8291 15.2443V5.50076H4.8291V4.41742H8.41244V3.51367H12.4124V4.41742H15.9958V5.50076H14.9958V15.2353C14.9958 15.6206 14.8663 15.9417 14.6072 16.1987C14.3482 16.4556 14.0311 16.5841 13.656 16.5841H7.16889ZM13.9124 5.50076H6.91244V15.2443C6.91244 15.3192 6.93646 15.3806 6.98452 15.4287C7.03257 15.4767 7.09403 15.5008 7.16889 15.5008H13.656C13.7201 15.5008 13.7789 15.474 13.8322 15.4205C13.8857 15.3672 13.9124 15.3085 13.9124 15.2443V5.50076ZM8.7491 14.0008H9.83223V7.00076H8.7491V14.0008ZM10.9926 14.0008H12.0758V7.00076H10.9926V14.0008Z"
                    fill="#4F4F4F" />
                </svg>
                Excluir
              </button>
            </div>

            <div v-if="cvPreviewUrl" class="cv-preview-thumbnail">
              <iframe :src="cvPreviewUrl" title="Pré-visualização do currículo" class="cv-preview-iframe" />
            </div>
          </div>
        </div>

      </div>
      <button class="nxp-continue-btn mt-16" :style="{ background: color }" @click="handleForward">{{ isEdit() ? "Salvar" : 'Continuar' }}</button>
    </div>

    <vs-popup title="" :active.sync="alert">
      <div class="popup-container">
        <h2 style="text-align: center">Seja bem-vindo(a) ao processo de candidatura!</h2>
        <div class="popup-container--image">
          <img src="@/assets/images/undraw_fitting_piece_re_pxay 1.svg"
            alt="Mulher negra mexendo em objetos abstratos." />
        </div>
        <p style="text-align: center">
          Aqui inicia sua inscrição na vaga. Seu perfil só será visível pelo contratante
          ao final deste cadastro, incluindo possíveis perguntas da empresa. Ao finalizar
          sua candidatura, não esqueça de realizar seu teste de perfil comportamental, que
          é extremamente importante para seu autoconhecimento.
        </p>
        <div class="popup-container--actions">
          <vs-button @click="handleReview">Completar meus Dados</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Overlay -->
    <div class="overlay" v-if="loadingDialog"></div>

    <!-- Loading Modal -->
    <vs-popup
      :active.sync="loadingDialog"
      title=""
      background-color="transparent"
      background-color-popup="#fff"
      :close="false"
      class="upload-popup"
    >
      <div class="upload-modal">
        <ReLoading :color="color" :isLoading="loadingDialog && !extractionFinished" />
        <div class="upload-modal__content">
          <h3 class="extraction-message">{{ loadingMessage }}</h3>
          
          <!-- Horizontal Timeline for Extraction Steps -->
          <div v-if="extractionSteps.length > 0" class="extraction-timeline">
            <div class="timeline-track" :style="{ background: `linear-gradient(90deg, ${color} 0%, #e0e7ff 100%)` }"></div>
            <div class="timeline-steps">
              <div 
                v-for="(step, index) in extractionSteps" 
                :key="index" 
                class="timeline-step"
                :class="{ 
                  'completed': step.completed, 
                  'active': step.active,
                  'pending': !step.completed && !step.active && !step.error,
                  'error': step.error
                }"
              >
                <div class="step-indicator" :style="getStepStyle(step, index)">
                  <template v-if="step.error">
                    <i 
                      class="material-icons step-icon" 
                      style="color: #e53935; cursor: pointer; font-size: 26px;"
                      @click="retryAllFailedExtractions"
                      title="Tentar novamente"
                    >refresh</i>
                  </template>
                  <template v-else>
                    <i class="material-icons step-icon">{{ step.completed ? 'check_circle' : step.icon }}</i>
                    <div v-if="step.active" class="pulse-ring" :style="{ borderColor: color }"></div>
                  </template>
                </div>
                <div class="step-label">
                  {{ step.label }}
                </div>
              </div>
            </div>
            <!-- Botão Fechar e Tentar Novamente se houver erro em algum passo -->
          </div>
          <div v-if="extractionFinished && extractionSteps.some(s => s.error)" style="margin-top: 18px; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 12px;">
            <div style="margin-bottom: 8px;">
              Ocorreu um erro na extração de {{ extractionErrorLabels }},<br>
              Você pode tentar novamente ou fechar
            </div>
            <div style="display: flex; justify-content: center; gap: 12px;">
              <vs-button
                v-if="canRetryExtraction"
                @click="retryAllFailedExtractions"
                color="primary"
              >Tentar Novamente</vs-button>
              <vs-button
                @click="handleExtractionClose"
                :color="'#F6F6F6'"
                style="margin-left: 12px; color: #333;"
              >Fechar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <!-- Extraction Confirmation Modal -->
    <vs-popup :active.sync="showExtractConfirmation" title="Extrair informações do currículo?">
      <div class="popup-container" style="font-size: 1.15rem;">
        <div style="text-align: center; font-size: 1.15rem; color: #222;">
          <div style="margin-bottom: 18px;">
            Podemos analisar seu currículo e preencher automaticamente alguns campos do seu perfil. As seguintes informações serão extraídas: endereço, habilidades, experiências, formações e idiomas.
          </div>
        </div>
        <div class="popup-container--actions">
          <vs-button color="primary" @click="startCVExtraction">Extrair informações</vs-button>
          <vs-button :color="'#F6F6F6'" @click="showExtractConfirmation = false" style="margin-left: 12px; color: #333;">Não, obrigado</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axios from "axios";
import { isEmpty, get, set, keys } from "lodash";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

/* eslint-disable */
import { mapState, mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";
import Tooltip from "../../components/tooltip/Tooltip.vue";
import ForwardButton from "@/components/ForwardButton";
import BackwardButton from "@/components/BackwardButton";
import ReLoading from "@/components/re-loading/ReLoading.vue";

export default {
  components: {
    VuePhoneNumberInput,
    ModelSelect,
    ForwardButton,
    BackwardButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Tooltip,
    ReLoading,
  },
  data: () => ({
    isMobile: false,
    maritalStatusChoices: [
      { value: "Solteiro(a)", label: "Solteiro(a)" },
      { value: "Casado(a)", label: "Casado(a)" },
      { value: "Divorciado(a)", label: "Divorciado(a)" },
      { value: "Viúvo(a)", label: "Viúvo(a)" },
      { value: "Separado(a)", label: "Separado(a)" },
    ],
    options: {
      genders: [],
    },
    payload: {
      ssn: "",
      name: "",
      birthday: "",
      telephone: "",
      linkedin_url: "",
      social_name: "",
      curriculum_filename: "",
      remuneration: "",
      gender: null,
    },
    social_name_tooltip:
      "No processo seletivo perguntamos qual é o nome que você quer ser chamado, mesmo que não seja o nome que está no documento de identidade. Assim, podemos respeitar sua identidade de gênero e ajudar a criar um ambiente de trabalho mais inclusivo para pessoas trans e não-binárias.",
    include_social_name: false,
    fileUpload: false,
    fileName: '',
    CVFileName: '',
    CvUploaded: false,
    localCurriculumFileName: null,
    cvObjectUrl: null,
    cvDocxPreviewUrl: null,
    fileCV: undefined,
    alert: false,
    jobPositionReference: '',
    loadingDialog: false,
    loadingMessage: "",
    currentExtractionIcon: null,
    extractionSteps: [],
    showExtractConfirmation: false,
    extractionRetryCount: 0,
    maxExtractionRetries: 2,
    extractionFinished: false,
    showSsnInput: true,
    telephoneError: "",
  }),
  mounted() {
    this.alert = true;

    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }
  },
  watch: {
    "payload.gender": function (newVal, oldVal) {
      if (newVal === null) {
        this.payload.gender = null;
      }
    },
    "payload.telephone"() {
      this.telephoneError = "";
    },
    basicFormSubmit({ trigger }) {
      if (trigger === true) {
        this.handleForward();
      }
    },
  },
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("auth", ["auth"]),
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
    ...mapState({
      basicFormSubmit: state => state.step.basicFormSubmit
    }),
    canRetryExtraction() {
      return (
        this.extractionRetryCount < this.maxExtractionRetries &&
        this.extractionSteps.some(s => s.error)
      );
    },
    extractionErrorLabels() {
      const errors = this.extractionSteps.filter(s => s.error).map(s => s.label);
      if (errors.length === 1) return errors[0];
      if (errors.length === 2) return errors.join(' e ');
      if (errors.length > 2) {
        return errors.slice(0, -1).join(', ') + ' e ' + errors[errors.length - 1];
      }
      return '';
    },
    cvPreviewUrl() {
      // PDF: blob URL from local file. DOCX: Google Docs Viewer via CDN URL.
      return this.cvObjectUrl || this.cvDocxPreviewUrl || null;
    },
    curriculumDisplayName() {
      if (this.localCurriculumFileName) return this.localCurriculumFileName;

      const url = this.payload && this.payload.curriculum_url;
      if (!url) return null;

      // Existing behavior when entering edit mode without uploading a new file.
      return url.split('/').pop().slice(0, 14) + '.pdf';
    },
    requiresProfileCompletion() {
      return this.showSsnInput;
    },
  },
  methods: {
    ...mapActions("basicInfo", [
      "setBasicInfo",
      "meBasic",
      "addUpdatePhotoUrl",
      "addCurriculumUrl"
    ]),
    ...mapActions("progress", ["calculateProgress"]),

    async fetchCompany() {
      try {
        const { company_label, vacancy_id } = this.$router.history.current.params;

        if (company_label && vacancy_id) {
          const response = await this.$http.get(
            `/api/v2/companies/${company_label}/${vacancy_id}`
          );

          const { name, logo_url, vacancy } = response.data.data;

          this.company = { ...this.company, name, logo_url };
          this.vacancy = { ...vacancy };

          this.jobPositionReference = vacancy.name;

          localStorage.setItem("vacancy_name", vacancy.name);

          // Identify customer
          woopra.identify({
            company: name,
          });

          // track
          // woopra.track();
        }

        if (company_label) {
          const response = await this.$http.get(`/api/v2/companies/${company_label}`);

          const { name, logo_url } = response.data.data;
          
          localStorage.setItem("vacancy_name", "");

          this.company = { ...this.company, name, logo_url };

          // Identify customer
          woopra.identify({
            company: name,
          });

          // track
          // woopra.track();
        }
      } catch (error) {
        error;
      }
    },

    validateTelephone() {
      const raw = (this.payload.telephone || "").replace(/\D/g, "");
      return raw.length >= 10 && raw.length <= 13;
    },
    async handleForward() {
      this.telephoneError = "";
      const isValid = await this.$validator.validate();
      if (!isValid) {
        await this.$store.dispatch("step/updateBasicFormSubmit", { trigger: false, goTo: undefined });
        const firstErrorField = this.errors.items[0].field;
        const firstErrorElement = document.querySelector(`[name="${firstErrorField}"]`);
        if (firstErrorElement) {
          firstErrorElement.focus();
        }
        return;
      }

      if (!this.validateTelephone()) {
        this.telephoneError = "Informe um telefone válido com DDD.";
        const el = document.getElementById("phonenumber");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      this.$vs.loading({ text: "Enviando..." });

      const { company_label } = this.$router.history.current.params;

      await this.$http
        .post('/api/v1/diversity', {
          ...this.$store.state.diversity,
          gender: this.payload.gender,
          social_name: this.payload.social_name,
          pronoun_id: get(this.$store.state.diversity, 'pronoun.id', null),
          is_egression: get(this.$store.state.diversity, 'is_egression') === true ? true : false,
          pcd_reability: get(this.$store.state.diversity, 'pcd_reability') === true ? true : false
        })
        .then(async (response) => {
          await this.$store.dispatch('diversity/addDiversity', response.data);
          set(this.payload, 'gender', this.$store.state.diversity.gender);
        })
        .catch(() => {});

        const parsedRemuneration = parseFloat(this.payload.remuneration.replaceAll('.', '').replace(',', '.'))
      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=basic`, {
          basicInfo: {
            ...this.payload,
            remuneration: parsedRemuneration === 0 ? null : parsedRemuneration,
          },
        })
        .then(async (response) => {
          this.$vs.loading.close();

          this.$store.dispatch("basicInfo/store", {
            ...this.payload,
          });

          if (this.onEditMode()) {
            this.$router.push({
              name: "dashboard-profile-detail",
            });
            return;
          }

          await this.$store.dispatch("step/completeStep");

          if (this.basicFormSubmit.trigger === true && typeof this.basicFormSubmit.goTo === 'number') {
            await this.$store.dispatch("step/updateCurrentStep", {
              order: this.basicFormSubmit.goTo,
              shouldTriggerBasicFormSubmit: false,
            });
          } else {
            await this.$store.dispatch("step/incrementCurrentStep");
          }

          const { path } = this.$store.getters["step/current"];

          const { params } = this.$router.history.current;

          this.$router.push({
            name: path,
            params,
          });
        })
        .catch(() => {
          this.$vs.loading.close();
        })
        .finally(async () => {
          await this.$store.dispatch("step/updateBasicFormSubmit", { trigger: false, goTo: undefined });
        }
      )
    },

    async handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }

      await this.$store.dispatch("step/decrementCurrentStep");

      const { path } = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: path,
        params,
      });
    },

    shouldDisplaySuccess() {
      return this.fileUpload;
    },
    isEdit() {
      return this.$router.history.current.path.includes('edit')
    },
    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    async handleFileUpload() {
      const file = this.$refs.file.files[0];

      if (file !== null || file !== undefined) {
        try {
          const { company_label } = this.$router.history.current.params;

          this.$vs.loading({
            text: "Salvando...",
          });

          const formData = new FormData();
          formData.append("photo_filename", file);

          const response = await this.$http.post(
            `api/v1/talent/${company_label}/user/talent/upload/photo`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          this.$vs.loading.close();

          if (response.status === 200) {
            this.fileUpload = true;
            this.fileName = file.name;
            this.payload = {
              ...this.payload,
              photo_url: response.data["photo_filename"],
            };
            this.addUpdatePhotoUrl(response.data["photo_filename"]);
          }
        } catch (error) {
          this.$vs.loading.close();

          this.$vs.notify({
            title: "Falha ao enviar foto",
            text:
              error.message ||
              "Falha ao realizar o procedimento contate a nossa equipe de suporte",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      }
    },

    async removeFile() {
      this.fileUpload = null;
      this.fileName = '';
      this.$refs.file.value = null;
    },

    getStepStyle(step, index) {
      const baseStyle = {};
      
      if (step.completed) {
        baseStyle.backgroundColor = '#4caf50';
        baseStyle.borderColor = '#4caf50';
        baseStyle.color = '#ffffff';
      } else if (step.active) {
        baseStyle.borderColor = this.color;
        baseStyle.color = this.color;
      }
      
      return baseStyle;
    },

    async handleCVUpload() {
      // Inicia a modal de carregamento
      this.currentExtractionIcon = "cloud_upload";
      this.loadingDialog = true;
      this.loadingMessage = "Enviando seu CV...";

      const file = this.$refs.fileCV.files[0];
      const formData = new FormData();
      formData.append("curriculum_filename", file);

      const token = localStorage.getItem("userToken");
      const { company_label } = this.$router.history.current.params;

      try {
        // PostHog: cv_sended
        try {
          const { trackEvent } = await import("@/services/posthog");
          trackEvent("cv_sended", { file_name: file && file.name });
        } catch (_) {}
        // 1) Faz o upload do CV (sem extração)
        const response = await axios.post(
          `${process.env.VUE_APP_CURRICULUM_SERVICE}/api/v1/talent/${company_label}/user/talent/upload/curriculum?debug=true`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Se "new" == false, não executa extrações
        const isCVNew = response.data["new"] === true;

        this.loadingMessage = "CV enviado com sucesso!";
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.loadingDialog = false;

        // Atualiza estados locais para indicar que o CV foi enviado
        this.CvUploaded = true;
        this.CVFileName = file.name;
        this.localCurriculumFileName = file.name;
        // PDF: blob URL (local, zero custo). DOCX: preview URL direto da API.
        const isPdf = Boolean(file) && (file.type === 'application/pdf' || /\.pdf$/i.test(file.name || ''));
        if (this.cvObjectUrl) URL.revokeObjectURL(this.cvObjectUrl);
        if (isPdf) {
          this.cvObjectUrl = URL.createObjectURL(file);
        } else {
          this.cvObjectUrl = null;
          this.cvDocxPreviewUrl = response.data["curriculum_filename"] || null;
        }

        this.payload.curriculum_filename = response.data["curriculum_filename"];
        this.payload.curriculum_url = response.data["curriculum_filename"];
        this.$store.dispatch("basicInfo/addCurriculumUrl", response.data["curriculum_filename"]);
        this.addCurriculumUrl(response.data["curriculum_filename"]);

        // Exibe mensagem de sucesso
        this.$vs.notify({
          title: "Sucesso!",
          text: "Currículo enviado com sucesso!",
          color: "success",
          iconPack: "feather",
          icon: "icon-check-circle",
          position: "top-right",
        });

        // Caso o back-end retorne alguma validação de arquivo
        if (response.data["validate"] && response.data["validate"]["result"] === false) {
          this.$vs.notify({
            title: "O Currículo foi salvo, Porém...",
            text: response.data["validate"]["message"] || "Porém, o arquivo enviado não parece ser um Currículo.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            time: 5000,
          });
        }

        // Track do evento
        window.woopra.track("curriculum-uploaded", {
          curriculum_filename: response.data["curriculum_filename"],
          valid: response.data["validate"] ? response.data["validate"]["result"] : null,
          valid_msg: (response.data["validate"] && response.data["validate"]["result"] === false)
            ? response.data["validate"]["message"]
            : null
        });
        // PostHog: cv_sended_success
        try {
          const { trackEvent } = await import("@/services/posthog");
          trackEvent("cv_sended_success", {
            curriculum_filename: response.data["curriculum_filename"],
            valid: response.data["validate"] ? response.data["validate"]["result"] : null,
          });
        } catch (_) {}

        // NEW: Ask user if they want to extract info from CV
        if (isCVNew) {
          this.showExtractConfirmation = true;
        }

      } catch (error) {
        // Fecha a modal em caso de erro
        this.loadingDialog = false;
        this.extractionSteps = [];

        if (!error.response) {
          this.$vs.notify({
            title: "Falha ao enviar curriculo",
            text: "O tamanho máximo do arquivo é de 15MB!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        } else {
          this.$vs.notify({
            title: "Falha ao enviar curriculo",
            text: error.response.data.errors[0].errors ||
              "Ocorreu um erro ao enviar o currículo. Atualize a página e tente novamente!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
        // PostHog: cv_sended_failed
        try {
          const { trackEvent } = await import("@/services/posthog");
          trackEvent("cv_sended_failed", {
            message: (error && error.response && error.response.data && error.response.data.message) || error.message || "upload_error",
            status: (error && error.response && error.response.status) || null
          });
        } catch (_) {}
      }
    },

    async removeFileCV() {
      if (this.cvObjectUrl) {
        URL.revokeObjectURL(this.cvObjectUrl);
      }
      this.cvObjectUrl = null;
      this.cvDocxPreviewUrl = null;
      this.localCurriculumFileName = null;

      this.CvUploaded = null;
      this.CVFileName = '';
      if (this.$refs.fileCV) {
        this.$refs.fileCV.value = null;
      }
      
      this.$vs.loading({
        text: "Removendo CV...",
      });
      
      const token = localStorage.getItem("userToken");
      
      axios
        .delete(
          `${process.env.VUE_APP_CURRICULUM_SERVICE}/api/v2/talents/profile/curriculum?debug=true`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    uploadedFile: function () {
      const { updated } = this.$router.history.current.query;
      this.CvUploaded = parseInt(updated);
    },

    checkCurriculumUrlBasicInfo: function () {
      this.CvUploaded = this.basicInfo.curriculum_url ? true : false;
    },

    doCaclulateProgress(e) {
      this.calculateProgress({ field: e.target.name, value: e.target.value });
    },

    handleReview() {
      this.alert = false;
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },

    handleMaskRemuneration(value) {
      const maskedValue = this.formatCurrency(value)
      this.payload.remuneration = maskedValue
    },

    formatCurrency(e) {
      let value = e;
      value = value.replace(/\D/g, "");
      value = value.replace(/(\d)(\d{2})$/, "$1,$2");
      value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
      return value;
    },

    phoneMask() {
      return this.payload.telephone && this.payload.telephone.length > 14
        ? "(##) #####-####"
        : "(##) ####-#####?";
    },

    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/basic-info`)
        : this.$ga.page(`${company_label}/step/basic-info`);
    },

    fetchBasicInfo() {
      this.$vs.loading({
        text: "Carregando...",
      });

      const { company_label } = this.$router.history.current.params;

      this.$http
        .get(`api/v1/talent/${company_label}/user/talent?step=basic`)
        .then((response) => {
          this.$vs.loading.close();

          const { basic, talent, professional_profile } = response.data.data;

          let currentValue = 0.00;

          if (professional_profile.intended_remuneration) {
            currentValue = professional_profile.intended_remuneration
          }

          const formatedRemuneration = this.formatCurrency(currentValue.toFixed(2));

          this.payload = Object.assign({}, this.payload, {
            ...basic,
            linkedin_url: talent.linkedin_url,
            remuneration: formatedRemuneration
          });

          // Define flag de exibição do CPF apenas uma vez com base no valor carregado
          this.showSsnInput = !(basic && basic.ssn && String(basic.ssn).trim() !== "");

          this.fileUpload = basic.photo_url !== null ? true : false;
          this.CvUploaded = basic.curriculum_url !== null ? true : false;

          // Identify customer
          woopra.identify({
            email: basic.email,
            name: basic.name,
            company: this.$router.history.current.params,
          });

          // track
          // woopra.track();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    fetchDiversityOptionsRequest() {
      this.$http
        .get("/api/v1/diversity?debug=true")
        .then((response) => {
          const { data = [] } = response;
          const dataKeys = keys(data);
          const options = {};

          dataKeys.forEach((key) => {
            set(
              options,
              key,
              data[key].map((item) => ({
                label: item.name,
                value: item.id,
                description: item.description ? item.description : null,
              }))
            );
          });

          this.options.genders = options.genders || [];

          const { gender, social_name } = this.$store.state.diversity;
          this.include_social_name = isEmpty(social_name) ? false : true;
          set(this.payload, 'social_name', social_name);
          const genderId = gender != null && typeof gender === 'object' ? gender.id : gender;
          set(this.payload, 'gender', genderId);
        })
        .catch(() => {});
    },

    // NEW: Start extraction after user confirms
    async startCVExtraction() {
      this.showExtractConfirmation = false;
      const dataTypes = [
        { type: "address", icon: "location_on", label: "Endereço", completed: false, active: false, error: false },
        { type: "skills", icon: "extension", label: "Habilidades", completed: false, active: false, error: false },
        { type: "experiences", icon: "work", label: "Experiências", completed: false, active: false, error: false },
        { type: "formations", icon: "school", label: "Formações", completed: false, active: false, error: false },
        { type: "languages", icon: "translate", label: "Idiomas", completed: false, active: false, error: false },
      ];
      this.extractionSteps = dataTypes;
      this.loadingDialog = true;
      this.loadingMessage = "Analisando seu currículo...";
      this.currentExtractionIcon = "search";
      this.extractionRetryCount = 0; // reset ao iniciar
      this.extractionFinished = false;
      window.woopra.track("cv-extraction-start");
      // PostHog: cv_extraction_clicked
      try {
        const { trackEvent } = await import("@/services/posthog");
        trackEvent("cv_extraction_clicked");
      } catch (_) {}
      await new Promise(resolve => setTimeout(resolve, 1500));
      for (let i = 0; i < dataTypes.length; i++) {
        dataTypes.forEach((step, index) => {
          step.active = index === i;
          step.completed = index < i && !step.error;
        });
        const { type, icon, label } = dataTypes[i];
        this.currentExtractionIcon = icon;
        this.loadingMessage = `Extraindo ${label.toLowerCase()}...`;
        await new Promise(resolve => setTimeout(resolve, 1500));
        try {
          await this.$http.post('/api/v2/assistant/chat', {
            feature: 'talent_curriculum_content_generate',
            feature_data: {
              talent_id: this.auth.user.talent.id,
              data_type: type,
            }
          });
          dataTypes[i].completed = true;
          dataTypes[i].active = false;
          dataTypes[i].error = false;
        } catch (e) {
          dataTypes[i].completed = false;
          dataTypes[i].active = false;
          dataTypes[i].error = true;
          dataTypes[i].errorMessage = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Erro ao extrair';
        }
        await new Promise(resolve => setTimeout(resolve, 300));
      }
      this.extractionFinished = true;
      this.currentExtractionIcon = "check_circle";
      this.loadingMessage = "Extração concluída!";
      await new Promise(resolve => setTimeout(resolve, 1500));
      // Só fecha se não houver erro
      if (!dataTypes.some(s => s.error)) {
        this.loadingDialog = false;
        this.extractionSteps = [];
        this.$vs.notify({
          title: "Sucesso!",
          text: "Currículo enviado e dados extraídos com sucesso!",
          color: "success",
          iconPack: "feather",
          icon: "icon-check-circle",
          position: "top-right",
        });
        await this.$http.get('/api/v1/alerts/extract-keywords');
      }
      // Se houver erro, botões serão exibidos pelo template
    },

    // Retry all failed extractions (up to 2 times)
    async retryAllFailedExtractions() {
      if (this.extractionRetryCount >= this.maxExtractionRetries) return;
      this.extractionRetryCount++;
      this.loadingMessage = 'Tentando novamente extrações...';
      this.extractionFinished = false;
      for (let i = 0; i < this.extractionSteps.length; i++) {
        const step = this.extractionSteps[i];
        if (step.error) {
          step.retrying = true;
          step.error = false;
          step.errorMessage = '';
          step.active = true;
          this.loadingMessage = `Extraindo ${step.label.toLowerCase()}...`;
          try {
            await this.$http.post('/api/v2/assistant/chat', {
              feature: 'talent_curriculum_content_generate',
              feature_data: {
                talent_id: this.auth.user.talent.id,
                data_type: step.type,
              }
            });
            step.completed = true;
            step.error = false;
          } catch (e) {
            step.completed = false;
            step.error = true;
            step.errorMessage = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Erro ao extrair';
          } finally {
            step.active = false;
            step.retrying = false;
          }
        }
      }
      this.extractionFinished = true;
      const hasErrors = this.extractionSteps.some(s => s.error);
      // Se ainda houver erro e atingiu o limite, fecha modal e mostra toast
      if (this.extractionRetryCount >= this.maxExtractionRetries && hasErrors) {
        this.loadingDialog = false;
        this.extractionSteps = [];
        await this.$http.get('/api/v1/alerts/extract-keywords');
        this.$vs.notify({
          title: 'Limite de tentativas',
          text: 'Não foi possível extrair todos os dados do currículo. Mas você pode preencher essas informações nas próximas etapas.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-right',
          duration: 10000,
        });
        return;
      }
      // Se todas deram certo, fecha modal normalmente
      if (!hasErrors) {
        this.loadingDialog = false;
        this.extractionSteps = [];
        this.$vs.notify({
          title: 'Sucesso!',
          text: 'Currículo enviado e dados extraídos com sucesso!',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          position: 'top-right',
        });
        await this.$http.get('/api/v1/alerts/extract-keywords');
      }
    },
    handleExtractionClose() {
      this.loadingDialog = false;
      this.extractionSteps = [];
      this.extractionFinished = false;
      // Se atingiu o limite, já mostra toast, senão não faz nada
      if (this.extractionRetryCount >= this.maxExtractionRetries && this.extractionSteps.some(s => s.error)) {
        this.$vs.notify({
          title: 'Limite de tentativas',
          text: 'Não foi possível extrair todos os dados. Por favor, tente novamente mais tarde.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-right',
        });
      }
    },
  },
  created() {
    this.$validator.extend("telephone", {
      getMessage: (field) =>
        `O ${field == "telephone" ? "telefone" : field} informado não é válido.`,
      validate: (value) => {
        const telephoneReg = /\(\d{2,}\) \d{4,}\-\d{4}/;
        return value.match(telephoneReg) || false;
      },
    });
    this.$validator.extend("cpf", {
      getMessage: (field) => `O ${field} informada não é valido`,
      validate: (value) => {
        const cpfReg = /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/;
        if (!value.match(cpfReg)) return false;

        const replaced = value.replace(/\./g, "").replace(/-/g, "");

        let sum = 0;
        let rest = 0;

        for (let i = 1; i <= 9; i++)
          sum += parseInt(replaced.substring(i - 1, i)) * (11 - i);
        rest = (sum * 10) % 11;

        if (rest == 10 || rest == 11) rest = 0;
        if (rest != parseInt(replaced.substring(9, 10))) return false;

        sum = 0;

        for (let i = 1; i <= 10; i++)
          sum += parseInt(replaced.substring(i - 1, i)) * (12 - i);
        rest = (sum * 10) % 11;

        if (rest == 10 || rest == 11) rest = 0;
        if (rest != parseInt(replaced.substring(10, 11))) return false;

        return true;
      },
    });
    this.$validator.extend("birthday", {
      getMessage: (field, params, data) =>
        (data && data.message) || "Erro não encontrado",
      validate: (value) => {
        return new Promise((resolve) => {
          const splitDate = value.split("/");

          const dayReg = /(0[1-9]|[12]\d|3[01])/;
          const monthReg = /0[1-9]|1[0-2]/;
          const yearReg = /(?:(?:19|20)[0-9]{2})/;

          if (!splitDate[0].match(dayReg))
            resolve({
              valid: false,
              data: {
                message: `O dia ${splitDate[0]} informado não é válido!`,
              },
            });
          if (!splitDate[1].match(monthReg))
            resolve({
              valid: false,
              data: {
                message: `O mês ${splitDate[1]} informado não é válido!`,
              },
            });
          if (!splitDate[2].match(yearReg))
            resolve({
              valid: false,
              data: {
                message: `O ano ${splitDate[2]} informado não é válido!`,
              },
            });

          resolve({ valid: true, data: "" });
        });
      },
    });
    this.$validator.extend("linkedin_domain", (value) => {
      return value.match(
        /((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/)((([\w]{2,3})?)|([^\/]+\/(([\w|\d-&#?=])+\/?){1,}))$/
      )
        ? true
        : false;
    });
    this.fileUpload =
      this.basicInfo.photo_url != undefined && this.basicInfo.photo_url != null;

    this.googleAnalytics();

    this.fetchBasicInfo();
    this.fetchDiversityOptionsRequest();

    this.fetchCompany();

    window.scroll(0, 0);

    if (parseInt(updated)) this.uploadedFile();

    if (!parseInt(updated)) this.checkCurriculumUrlBasicInfo();

    // Se por algum motivo a API não preencher, garanta a flag inicial
    if (this.showSsnInput === undefined || this.showSsnInput === null) {
      this.showSsnInput = !(this.payload && this.payload.ssn && String(this.payload.ssn).trim() !== "");
    }
  },
  beforeDestroy() {
    if (this.cvObjectUrl) {
      URL.revokeObjectURL(this.cvObjectUrl);
    }
    this.cvObjectUrl = null;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";

.file {
  position: relative;
  height: 40px;
  width: 200px;
}

.file>input[type="file"] {
  height: 40px;
  width: 200px;
  position: absoulte;
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}

.file>label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  color: rgb(32, 100, 178);
  border: 1px solid rgb(32, 100, 178);
  border-radius: 5px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.revision__container {
  overflow-x: scroll;
}

.nxp-profile-completion-alert {
  padding: 10px 12px;
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 6px;
}

.nxp-profile-completion-alert__text {
  font-size: 14px;
  color: #1565c0;
  font-weight: 500;
}

.warning__container {
  padding: 8px;
  background-color: #ff9f43;
  border-radius: 2px;
  margin-bottom: 16px;

  color: #191919;
}

.warning__title {
  display: flex;
  align-items: center;
  font-weight: 600;
}

.warning__description {
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;

  button {
    padding: 0 !important;
    color: #0000ff !important;
    font-weight: 600 !important;
  }
}

.vs-popup--header {
  background: #fff;
}

.popup-container {
  width: 100%;

  h2 {
    // font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 23px;
    color: #172b4d;
  }

  p {
    // font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #172b4d;
  }

  &--image {
    margin: 20px 0;
    display: flex;
    text-align: center;
    justify-content: center;

    img {
      width: 281px;
      height: 288px;
    }

    @media (max-width: 768px) {

      /* Aplique estilos apenas em telas com largura máxima de 768 pixels (dispositivos móveis) */
      img {
        max-width: 161;
        max-height: 168px;
        width: auto;
        height: auto;
      }
    }
  }

  &--actions {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.vs-dialog {
  &.loading-dialog {
    .vs-dialog__content {
      padding: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      
      h4 {
        text-align: center;
        margin-bottom: 16px;
        color: #4f4f4f;
      }
    }
  }
}

.loading-dialog-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}

.loading-message {
  margin: 16px 0 0;
  text-align: center;
  font-weight: normal;
  color: #4f4f4f;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

.upload-popup {
  z-index: 1001;

  ::v-deep .vs-popup__container {
    min-width: 320px !important;
    max-width: 400px !important;
    min-height: 360px !important;
    display: flex;
    justify-content: center;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  }
  ::v-deep .vs-popup--header{
    display: none;
  }
}

.upload-modal {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  width: 100%;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}

.extraction-message {
  margin: 8px 0 0 0;
  font-size: 18px;
  font-weight: 500;
  color: #4f4f4f;
  animation: fadeIn 0.3s ease-in-out;
}

/* Horizontal Timeline Styles */
.extraction-timeline {
  width: 100%;
  position: relative;
  padding: 16px 0 0 0;
}

.timeline-track {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 3px;
  transform: translateY(-15px);
  border-radius: 4px;
  z-index: 1;
}

.timeline-steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  z-index: 2;
}

.timeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  transition: all 0.3s ease;
  
  .step-indicator {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #f5f5f5;
    border: 2px solid #bdbdbd;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    position: relative;
    transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    
    .step-icon {
      font-size: 26px;
      transition: all 0.3s ease;
    }
  }
  
  .step-label {
    font-size: 15px;
    font-weight: 500;
    color: #4f4f4f;
    max-width: 90px;
    opacity: 0.8;
    transition: all 0.3s ease;
  }
  
  &.completed {
    .step-indicator {
      transform: scale(1.1);
    }
    
    .step-label {
      font-weight: 600;
      opacity: 1;
    }
  }
  
  &.active {
    .step-indicator {
      transform: scale(1.2);
      box-shadow: 0 0 0 5px rgba(21, 81, 177, 0.2);
    }
    
    .step-label {
      font-weight: 600;
      opacity: 1;
    }
  }
  
  &.pending {
    .step-indicator {
      background-color: #f9f9f9;
      border-color: #e0e0e0;
    }
    
    .step-icon {
      color: #bdbdbd;
    }
    
    .step-label {
      color: #bdbdbd;
      opacity: 0.6;
    }
  }
}

.pulse-ring {
  position: absolute;
  top: -8px;
  left: -8px;
  right: -8px;
  bottom: -8px;
  border: 2px solid;
  border-radius: 50%;
  animation: pulsate 1.5s ease-out infinite;
}

@keyframes pulsate {
  0% {
    transform: scale(0.8);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.2;
  }
  100% {
    transform: scale(0.8);
    opacity: 0.8;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Ensure steps appear with staggered animation */
.timeline-step:nth-child(1) {
  animation: scaleIn 0.4s ease-out forwards;
}
.timeline-step:nth-child(2) {
  animation: scaleIn 0.4s 0.1s ease-out forwards;
}
.timeline-step:nth-child(3) {
  animation: scaleIn 0.4s 0.2s ease-out forwards;
}
.timeline-step:nth-child(4) {
  animation: scaleIn 0.4s 0.3s ease-out forwards;
}
.timeline-step:nth-child(5) {
  animation: scaleIn 0.4s 0.4s ease-out forwards;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .timeline-step .step-label {
    font-size: 12px;
    max-width: 70px;
  }
  
  .timeline-step .step-indicator {
    width: 40px;
    height: 40px;
  }
  
  .timeline-step .step-indicator .step-icon {
    font-size: 20px;
  }
}

@media (max-width: 600px) {
  .extraction-timeline {
    padding: 16px 0 0 0;
    width: 100%;
    min-height: 0;
    height: auto;
    order: 2;
  }
  .timeline-track {
    display: none !important;
  }
  .timeline-steps {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 0;
    align-items: start;
    justify-items: center;
    width: 100%;
  }
  .timeline-step {
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start;
    margin-bottom: 24px;
    width: 100%;
    min-height: 60px;
    position: relative;
    z-index: 2;
    display: flex;
  }
  .timeline-step:last-child {
    margin-bottom: 0;
  }
  .timeline-step .step-indicator {
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    margin-bottom: 8px;
    margin-right: 0;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .timeline-step .step-label {
    font-size: 13px;
    max-width: 90px;
    text-align: center;
    opacity: 0.9;
    font-weight: 500;
    margin: 0;
    margin-top: 2px;
  }
  .pulse-ring {
    top: -6px;
    left: -6px;
    right: -6px;
    bottom: -6px;
  }
  .popup-container--actions {
    flex-direction: column !important;
    gap: 10px;
    align-items: stretch;
  }
  .popup-container--actions .vs-button {
    width: 100%;
    margin-left: 0 !important;
  }
  
  /* Reorganize extraction error buttons */
  .upload-modal__content {
    display: flex;
    flex-direction: column;
  }
  
  .upload-modal__content > div[style*="margin-top: 18px"] {
    order: 1;
    margin-bottom: 20px !important;
    margin-top: 0 !important;
  }
  
  .upload-modal__content > div[style*="margin-top: 18px"] > div[style*="display: flex"] {
    flex-direction: column !important;
  }
  
  .upload-modal__content > div[style*="margin-top: 18px"] .vs-button {
    width: 100%;
    margin-left: 0 !important;
    margin-bottom: 10px;
  }
}

::v-deep .vs-loading__load {
  &__animation {
    transform: scale(0.9);
  }
  &__text {
    display: none;
  }
}

.cv-uploaded-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cv-preview-thumbnail {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 0.5px solid #A8A8A8;
  background: #fff;
}

.cv-preview-iframe {
  width: 100%;
  height: 260px; // show only the top part so it behaves like a "thumbnail"
  border: 0;
  display: block;
}

.cv-filename-link {
  display: inline-block;
  width: 100%;
  color: var(--Texto-Primrio);
  text-decoration: underline;
  font-weight: 500;
  word-break: break-word;
}

.gender {
  $text-color: #172b4d;
  $font-family: Roboto;

  margin: 0.3125rem auto;

  h2 {
    color: $text-color;
    font-family: $font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.32px;
  }

  p {
    color: $text-color;
    font-family: $font-family;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.28px;
    text-wrap: wrap;
    margin: 0.625rem 0;
  }
}
</style>


